/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Parameters for lecturer session reminder job.

Sends lightweight reminder emails to lecturers before sessions that require
their presence (e.g. proctored exams, oral exams). Only fires for event kinds
where send_lecturer_reminder_hours_before is set AND send_briefing=False
(to avoid suppressing the richer AI briefing with a simpler reminder).
 */
export interface LecturerSessionReminderParams {
  [key: string]: unknown;
}
